import { createFileRoute } from "@tanstack/react-router";
import { parseCustomerChatsSearch } from "@/features/customer-chat/route-search";

// Tham số URL (mục đối tác, luồng đang mở) — xem route-search.ts.
export const Route = createFileRoute("/_app/customer-chats")({
  validateSearch: parseCustomerChatsSearch,
});
